import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const WhyUs = () => {
  const points = ['une expertise pointue du détatouage', 'une formation continue sur les technologies laser', 'un accompagnement adapté au type de peau', 'une évaluation réaliste des résultats'];
  return <section id="why-us" className="py-24 md:py-40 lg:py-56 bg-brand-darker relative overflow-hidden" data-id="element-197">
      {/* Texture Overlay */}
      <div className="absolute inset-0 z-0 opacity-10 mix-blend-overlay pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8r1uSXfQqTYF1RUcvvVyLa/background.jpg)',
      backgroundSize: '400px',
      backgroundRepeat: 'repeat'
    }} data-id="element-198" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative z-10" data-id="element-199">
        <div className="max-w-6xl mx-auto text-center mb-16 md:mb-24 lg:mb-32" data-id="element-200">
          <ScrollReveal blur scale duration={1.2} data-id="element-201">
            <h2 className="text-4xl md:text-4xl lg:text-6xl xl:text-7xl font-medium text-brand-light mb-6 md:mb-10 tracking-tight leading-[1.2] text-balance pt-[10px] pb-[10px]" data-id="element-202">
              Pourquoi Choisir Dispel Your Tattoo pour votre Détatouage en
              Valais ?
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={0.2} blur data-id="element-203">
            <h3 className="md:text-2xl lg:text-[2rem] font-medium text-brand-gray tracking-tight text-[40px]" data-id="element-204">
              Expertise, Précision et Approche Personnalisée
            </h3>
          </ScrollReveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 lg:gap-16 mb-16 md:mb-24 lg:mb-32" data-id="element-205">
          {points.map((point, index) => <div key={index} className="relative pt-8 md:pt-10" data-id="element-206">
              <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1,
            delay: 0.3 + index * 0.15,
            ease: [0.16, 1, 0.3, 1]
          }} className="absolute top-0 left-0 w-full h-[1px] bg-brand-border/50 origin-left" data-id="element-207" />
              <ScrollReveal delay={0.4 + index * 0.15} blur direction="none" distance={0} data-id="element-208">
                <span className="text-xs md:text-sm font-bold text-brand-light/20 block mb-4 md:mb-6 tracking-widest" data-id="element-209">
                  0{index + 1}
                </span>
                <p className="text-lg md:text-xl lg:text-2xl text-brand-light font-medium tracking-tight leading-snug" data-id="element-210">
                  {point}
                </p>
              </ScrollReveal>
            </div>)}
        </div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-211">
          <ScrollReveal delay={0.8} blur direction="up" distance={40} data-id="element-212">
            <p className="text-xl md:text-3xl lg:text-4xl text-brand-gray font-light leading-relaxed text-balance" data-id="element-213">
              Mon objectif est de fournir un détatouage sûr, maîtrisé et de
              haute qualité, dans le respect total de votre peau.
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>;
};